import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import useInputAndDropdownTheme from 'hb-react/shared/hooks/theme/useInputAndDropdownTheme';

const OtherAmount = ({
  campaign,
  otherAmount,
  name,
  biggerDisplay = false,
  onChange,
  onBlur,
}) => {
  const inputAndDropdownTheme = useInputAndDropdownTheme();

  return (
    <CustomFundWrapper $biggerDisplay={biggerDisplay}>
      <i
        style={{
          color: inputAndDropdownTheme.color,
        }}
      >
        {campaign.currency.symbol}
      </i>
      <div className="input flush">
        <StyledInput
          type="number"
          name={name}
          value={otherAmount}
          min="0"
          step="any"
          placeholder={__('Amount')}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
        />
      </div>
    </CustomFundWrapper>
  );
};

OtherAmount.propTypes = {
  campaign: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  biggerDisplay: PropTypes.bool,
  otherAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OtherAmount;

const StyledInput = styled.input`
  ${({ theme }) => css`
    background: ${theme.input.bg} !important;
    color: ${theme.input.color} !important;
    border-color: ${theme.input.borderColor} !important;
    font-size: 1.1em;
    font-weight: 600;

    ::placeholder {
      color: ${theme.input.placeholder} !important;
      font-weight: normal;
    }
  `}
`;

const CustomFundWrapper = styled.div`
  display: inline-block;
  position: relative;

  input {
    padding-right: 12px !important;
    padding-left: 28px !important;
    text-align: right;
    border: 1px solid #737373;
    width: 100%;
  }

  i {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0;
    left: 10px;
    right: auto;
    font-size: 16px;
  }

  ${(props) =>
    props.$biggerDisplay &&
    `
    input {
      height: 61px;
      border-radius: 6px;
      font-size: 18px !important;
      padding-left: 34px !important;
      text-align: left;
    }

    i {
      font-size: 18px;
      margin-top: 1px;
    }
  `}
`;
